import React, { ReactElement } from 'react';
import Svg, { Path } from 'react-native-svg';

import { IconStyles } from './types';

export const Arrow = ({
  size,
  style,
}: {
  size: number;
  style?: IconStyles;
}): ReactElement => {
  return (
    <Svg width={size} height={size} viewBox="0 0 9 14" style={style}>
      <Path
        d="M0.666585 1L7.33325 7L0.666585 13"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke={style?.color || 'currentColor'}
        fill={'none'}
      />
    </Svg>
  );
};
